var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitor-attributes" } },
    [
      _c("a-alert", {
        attrs: {
          description: _vm.$t("settings.toInformDescription"),
          type: "info",
          "show-icon": "",
        },
      }),
      _vm._v(" "),
      _c("a-table", {
        key: "attr-table",
        staticClass: "attr-table",
        attrs: {
          columns: _vm.columns,
          "data-source": _vm.getAttributes(),
          pagination: false,
        },
        scopedSlots: _vm._u([
          {
            key: "name",
            fn: function (text, record) {
              return _c(
                "div",
                {
                  key: "name",
                  staticStyle: { width: "100px" },
                  on: {
                    click: function ($event) {
                      _vm.editAttributeId = record._id
                      _vm.editAttributeValue = text
                    },
                    mouseleave: function ($event) {
                      _vm.editAttributeId = null
                    },
                  },
                },
                [
                  _vm.editAttributeId == record._id
                    ? _c(
                        "div",
                        [
                          _c("a-input", {
                            staticClass: "edit-input",
                            on: {
                              change: function ($event) {
                                return _vm.updateAttributeName(
                                  record._id,
                                  _vm.editAttributeValue
                                )
                              },
                            },
                            model: {
                              value: _vm.editAttributeValue,
                              callback: function ($$v) {
                                _vm.editAttributeValue = $$v
                              },
                              expression: "editAttributeValue",
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "attr-name" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" edit_note "),
                        ]),
                        _vm._v(" " + _vm._s(text)),
                      ]),
                ]
              )
            },
          },
          {
            key: "usingVisitor",
            fn: function (usingVisitor) {
              return _c(
                "span",
                { key: "usingVisitor" },
                [
                  _c("a-button", { attrs: { disabled: "" } }, [
                    _vm._v(_vm._s(_vm.$t("settings.showVisitor"))),
                  ]),
                ],
                1
              )
            },
          },
          {
            key: "visible",
            fn: function (text, record) {
              return _c(
                "span",
                {},
                [
                  _c("a-switch", {
                    staticClass: "md-warning ml-3",
                    attrs: { name: "writing" },
                    on: {
                      change: function ($event) {
                        return _vm.updateAttrVisible(record._id, text)
                      },
                    },
                    model: {
                      value: record.visible,
                      callback: function ($$v) {
                        _vm.$set(record, "visible", $$v)
                      },
                      expression: "record.visible",
                    },
                  }),
                ],
                1
              )
            },
          },
          {
            key: "process",
            fn: function (text, record) {
              return _c(
                "div",
                { key: "process" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "process-button",
                      attrs: { type: "danger", shape: "circle" },
                      on: {
                        click: function ($event) {
                          return _vm.deleteAttribute(record._id)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("delete"),
                      ]),
                    ]
                  ),
                ],
                1
              )
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }